import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiError, AuthService, BaseVisualizacao, BaseVisualizacaoService, ConfigService, DataTablesService, MessageService, VisualizacaoStorageService, Task, TaskService } from '../../core';
import { ConfigEmpresa, isConfigEmpresaVersaoIntegracaoErp1 } from '../configuracoes/app/empresa';
import { IntegrationCondicaoPagamento, IntegrationCondicaoPagamentoHttpService } from '../configuracoes/integration/condicao-pagamento';
import { CondicaoPagamentoCrudHttpService } from './services';

import { CondicaoPagamento } from './condicao-pagamento';
import { CondicaoPagamentoFilter, CondicaoPagamentoFilterCollapseComponent } from './filter';
import { CondicaoPagamentoOptions } from './condicao-pagamento-options';
import { CondicaoPagamentoImportModalComponent } from './import-modal';

@Component({
    selector: 'sgt-condicao-pagamento',
    templateUrl: './condicao-pagamento.component.html',
    styleUrls: ['./condicao-pagamento.component.less']
})
export class CondicaoPagamentoComponent implements BaseVisualizacao<CondicaoPagamento>, OnInit {
    configEmpresa: ConfigEmpresa;
    isIntegracaoErpV1: boolean;
    isAdministrador: boolean;

    entities: CondicaoPagamento[];
    dataTable: any;

    // Options
    options: CondicaoPagamentoOptions;

    // Filter
    filter = new CondicaoPagamentoFilter();
    @ViewChild('filterCollapse', {static: true}) filterCollapse: CondicaoPagamentoFilterCollapseComponent;
    @ViewChild('containerTable', {static: true}) containerTable: ElementRef;

    @ViewChild('importModal') importModal: CondicaoPagamentoImportModalComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private configService: ConfigService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private taskService: TaskService,
                private condicaoPagamentoCrudHttpService: CondicaoPagamentoCrudHttpService,
                private integrationCondicaoPagamentoHttpService: IntegrationCondicaoPagamentoHttpService) { }


    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isIntegracaoErpV1 = isConfigEmpresaVersaoIntegracaoErp1(this.configEmpresa);
        this.isAdministrador = this.authService.isAdministrador();

        this.createOptions();
    }

    /** Cria as opções disponíveis para serem executadas pelos usuários */
    private createOptions() {
        this.options = new CondicaoPagamentoOptions();
        // Import ERP v1
        this.options.canImportErp_v1 = this.canImportErp_v1();
        // Importar
        this.options.canImport = this.isAdministrador;
    }

    onFilterInitialized() {
        // Obtendo os dados armazenados da visualização
        const vs = this.visualizacaoStorageService.get();
        if (vs != null) {
            // Se possuir os dados, então setamos o filtro, a página e a ordenação da tabela com os seus valores armazenados
            vs.filterValues.forEach((value, key) => this.filter[key] = value);
            this.filterCollapse.isFilterDirty = true;

            this.search();
        } else {
            this.search();
        }
    }

    clearFilter() {
        this.filterCollapse.clear()
        this.dataTable.search('');
    }

    private closeFilter() {
        this.filterCollapse.close();
        jQuery(this.containerTable.nativeElement).scrollTop(0);
    }

    search() {
        this.condicaoPagamentoCrudHttpService.searchWithFilter(this.filter)
            .subscribe(
                entities => {
                    this.entities = entities;
                    this.afterSearch();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as condições de pagamentos', error)
            );
    }

    private afterSearch() {
        this.showTable();
        this.closeFilter();
    }

    showTable() {
        this.dataTablesService.showTable('#tableCondicoesPagamentos ', this.dataTable)
            .then(dataTable => {
                this.dataTable = dataTable;
                this.baseVisualizacaoService.ativarArmazenamento(this.dataTable, this.filter);
            });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: CondicaoPagamento) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: CondicaoPagamento) {
        this.messageService.confirm(`Deseja realmente excluir a condição de pagamento: ${entity.nome}?`).then(result => {
            if (result) {
                this.condicaoPagamentoCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir a condição de pagamento: ${entity.nome}`, error)
                    );
            }
        });
    }

    /** Abre o modal para importar as Condições de Pagamento */
    openImportModal() {
        this.importModal.open();
    }

    onAfterImport() {
        this.search();
    }

    /** Verifica se pode importar as condições de pagamentos do ERP V1 */
    private canImportErp_v1(): boolean {
        // Somente se for a versão 1
        if (!this.isIntegracaoErpV1) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

     /** Executa a integração de leitura das condições depagamentos com os sistemas ERP's */
    importErp_v1() {
        const task = new Task('Importando as condições de pagamentos do sistema ERP', 'Executando importação das condições de pagamentos do sistema ERP');
        this.taskService.add(task, task.description);

        const entityIntegration = new IntegrationCondicaoPagamento();
        this.integrationCondicaoPagamentoHttpService.execReadIntegration(entityIntegration)
            .subscribe(
                () => {
                    this.taskService.success(task, 'Importação das condições de pagamentos do sistema ERP realizada com sucesso');
                    this.search();
                },
                (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a importação das condições de pagamentos do sistema ERP', error.message, error)
            );
    }
}
